// extracted by mini-css-extract-plugin
export default {"timer-selector":"TimerSelector_timer-selector__FTZl8"};